// Fritsch-Carlson tangents keep each cubic within its neighbouring values.
export function monotonePath(points) {
  if (points.length < 2) return "";
  const slopes = points.slice(1).map((p, i) => (p[1] - points[i][1]) / (p[0] - points[i][0]));
  const tangents = points.map((_, i) => {
    if (i === 0) return slopes[0];
    if (i === points.length - 1) return slopes[i - 1];
    return slopes[i - 1] * slopes[i] <= 0 ? 0 : (slopes[i - 1] + slopes[i]) / 2;
  });
  slopes.forEach((slope, i) => {
    if (slope === 0) {
      tangents[i] = tangents[i + 1] = 0;
    } else {
      const length = Math.hypot(tangents[i] / slope, tangents[i + 1] / slope);
      if (length > 3) {
        tangents[i] *= 3 / length;
        tangents[i + 1] *= 3 / length;
      }
    }
  });
  let d = `M${points[0][0]},${points[0][1]}`;
  points.slice(1).forEach((p, i) => {
    const previous = points[i];
    const dx = (p[0] - previous[0]) / 3;
    d += ` C${previous[0] + dx},${previous[1] + dx * tangents[i]} ${p[0] - dx},${p[1] - dx * tangents[i + 1]} ${p[0]},${p[1]}`;
  });
  return d;
}

// Split lines at missing or non-finite values without losing their category positions.
export function nonNullRuns(values, xAt, yAt) {
  const runs = [];
  let current = [];
  values.forEach((v, i) => {
    if (v == null || !Number.isFinite(v)) {
      if (current.length) runs.push(current);
      current = [];
    } else {
      current.push([xAt(i), yAt(v)]);
    }
  });
  if (current.length) runs.push(current);
  return runs;
}
